<template>
  <div class="faq_page" ref="middle_page">
    <div class="" style="height: 10px"></div>
    <div class="faq_box">
      <p class="faq">vấn đề chung</p>
      <el-collapse class="collapse" v-model="activeNames" @change="handleChange" accordion>
        <el-collapse-item name="1">
          <template slot="title">
            <i class="header-icon el-icon-info i-style" style="color:white;"></i><font style="color: white">我忘记密码了，怎么办？</font>
          </template>
          <div>1.在【账号密码登录】模块中，点击忘记密码按钮，按照提示步骤进行操作。</div>
          <div>2.操作完成后，重新登录StudyArts，用新密码登录即可。</div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <i class="header-icon el-icon-info i-style" style="color:white;"></i><font style="color: white">我忘记密码了，怎么办？</font>
          </template>
          <div>1.在【账号密码登录】模块中，点击忘记密码按钮，按照提示步骤进行操作。</div>
          <div>2.操作完成后，重新登录StudyArts，用新密码登录即可。</div>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <i class="header-icon el-icon-info i-style" style="color:white;"></i><font style="color: white">我忘记密码了，怎么办？</font>
          </template>
          <div>1.在【账号密码登录】模块中，点击忘记密码按钮，按照提示步骤进行操作。</div>
          <div>2.操作完成后，重新登录StudyArts，用新密码登录即可。</div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
  export default {
    name: "faq",
    data() {
      return {
        activeNames: ['1']
      };
    },
    methods: {
      handleChange(val) {
        // console.log(val);
      }
    }
  }
</script>

<style>
  .faq_page {
    height: 100%;
    position: relative;
    background: url(../../../static/images/bg/personset_bg2.jpg);
    background-size: cover;
    position: relative;
    /*min-width: 1200px;*/
  }

  .faq_box {
    max-width: 600px;
    padding: 0px 20px 20px;
    margin: 0px auto;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 15px;
    display: grid;
    z-index: 2;
    position: relative;
  }


  .faq {
    margin-bottom: 10px;
    height: 30px;
    line-height: 30px;
    margin-top: 30px;
    font-size: 25px;
    color: rgb(250, 250, 250);
    /* font-family: museo-slab-w01-100,serif; */
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
    text-align: center;
  }

  .i-style {
    margin-left: 5px;
    margin-right: 5px;
  }

  .el-collapse-item__header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 48px;
    line-height: 48px;
    /*background-color: rgba(0, 0, 0, 0);*/
    /*color: #303133;*/
    cursor: pointer;
    border-bottom: 1px solid #EBEEF5;
    font-size: 13px;
    font-weight: 500;
    -webkit-transition: border-bottom-color .3s;
    transition: border-bottom-color .3s;
    outline: 0;
    background-color: rgba(153, 153, 151, 0.35);
    color: rgb(232, 230, 230);
    /* font-family: museo-slab-w01-100,serif; */
  }
  .el-collapse-item__content {
    color: white;
    padding-bottom: 5px;
    padding-top: 5px;
    padding-left: 5px;
    padding-right: 5px;
    font-size: 13px;
    background-color:rgba(153, 153, 151, 0.35)!important ;
  }
  .el-collapse-item__wrap {
    will-change: height;
    background-color:transparent;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-bottom: 1px solid #EBEEF5;
  }
  .faq_content {
  }
  .el-collapse {
    border-top: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/faq_vi.vue